// extracted by mini-css-extract-plugin
export default {"tabList":"MCP8ujNYwOPXTK4jC_du"};